import createComponent from "@/utils/create-component";
import InternalLinksSection from "@/component-library/internal-links-section";

createComponent({
  el: "#internal-links-section",
  component: InternalLinksSection
});
